import { PageContent, PageHeader } from "@/components/page-components";
import { PendingProjectsComponent } from "@/components/pending";
import { ProjectList } from "@/components/project/project-list";
import { QueryBoundary } from "@/components/query-boundary";
import { createFileRoute } from "@tanstack/react-router";
import { useDeferredValue, useState } from "react";
import { SearchInput } from "@papier/ui/components/ui/search-input";

export const Route = createFileRoute("/_app/projects/")({
  component: ProjectsPage,
  loader: ({ context: { queryClient, trpc } }) => {
    queryClient.ensureQueryData(trpc.projects.getAll.queryOptions());
  },
  head: () => ({
    meta: [{ title: "Papier - Projects" }],
  }),
});

function ProjectsPage() {
  const [searchValue, setSearchValue] = useState("");
  const defferedQuery = useDeferredValue(searchValue);

  return (
    <main>
      <PageHeader>
        <div className="px-4 py-2">
          <SearchInput
            placeholder="Search projects..."
            value={searchValue}
            onChange={setSearchValue}
          />
        </div>
      </PageHeader>
      <PageContent>
        <h2 className="pb-4 text-lg font-medium">All Projects</h2>
        <QueryBoundary suspenseFallback={<PendingProjectsComponent />}>
          <ProjectList query={defferedQuery} />
        </QueryBoundary>
      </PageContent>
    </main>
  );
}
